import React from 'react';

interface AppContext {
  state: {
    groups: number;
    frames: number;
  };
}

const Context = React.createContext<AppContext>({
  state: {
    groups: 0,
    frames: 0,
  },
});

export const AppProvider = Context.Provider;

export function useApp(): AppContext {
  return React.useContext(Context);
}
